import React, { useId } from 'react';
import { Control, Controller } from 'react-hook-form';

import { Switch, cn } from '@column/ui';

import { Permissions } from '../types';

interface PermissionTogglesProps {
  control: Control;
  parentPermissions?: Permissions;
  permissionsToLabelsMap: { [permission: string]: string };
  fieldPathPrefix?: string;
}
export const PermissionToggles: React.FC<PermissionTogglesProps> = ({
  control,
  parentPermissions,
  fieldPathPrefix,
  permissionsToLabelsMap,
}) => {
  const idPrefix = useId();
  const maxColumns = 3;
  const itemsPerColumn = Math.ceil(Object.entries(permissionsToLabelsMap).length / maxColumns);

  return (
    <div className="flex flex-wrap gap-4">
      {[...Array(maxColumns)].map((_, columnIndex) => (
        <div key={columnIndex} className="flex flex-[1_0_200px] flex-col gap-4">
          {Object.entries(permissionsToLabelsMap)
            .slice(columnIndex * itemsPerColumn, (columnIndex + 1) * itemsPerColumn)
            .map(([permission, label]) => (
              <Controller
                key={permission}
                name={`${fieldPathPrefix ? `${fieldPathPrefix}.` : ''}${permission}`}
                control={control}
                render={({ field }) => {
                  const effectivePermission = field.value !== 'default' ? field.value : parentPermissions?.[permission];
                  const isChecked =
                    effectivePermission && effectivePermission !== 'default' ? effectivePermission === 'write' : false;
                  const isOverride = !!parentPermissions && field.value !== 'default';
                  return (
                    <div className="flex items-center gap-3">
                      <Switch
                        id={`${idPrefix}-${permission}`}
                        checked={isChecked}
                        onCheckedChange={(newIsChecked) => field.onChange(newIsChecked ? 'write' : 'read')}
                      />
                      <label
                        htmlFor={`${idPrefix}-${permission}`}
                        className={cn(
                          'cursor-pointer text-sm leading-[18px] font-medium',
                          isOverride ? 'text-primary dark:text-blue-400' : 'text-foreground'
                        )}
                      >
                        {label}
                      </label>
                    </div>
                  );
                }}
              />
            ))}
        </div>
      ))}
    </div>
  );
};
